<!--  -->
<template>
  <div>2222222222222</div>
</template>

<script>
import url from '_conf/url'
export default {
  name: 'test',
  data () {
    return {
      websock: null
    }
  },
  created () {
    this.initWebSocket()
  },
  destroyed () {
    this.websock.close() // 离开路由之后断开websocket连接
  },
  methods: {
    initWebSocket () { // 初始化weosocket
      let baseUrl = url.replace(/(http)|(https)/, 'ws')
      const wsuri = `${baseUrl}/websocket/1`
      this.websock = new WebSocket(wsuri)
      this.websock.onmessage = this.websocketonmessage
      this.websock.onopen = this.websocketonopen
      this.websock.onerror = this.websocketonerror
      this.websock.onclose = this.websocketclose
      console.log(wsuri)
    },
    websocketonopen () { // 连接建立之后执行send方法发送数据
      let actions = { 'test': '12345' }; this.websocketsend(JSON.stringify(actions))
    },
    websocketonerror () { // 连接建立失败重连
      this.initWebSocket()
    },
    websocketonmessage (e) { // 数据接收
      const redata = JSON.parse(e.data)
      console.log(redata)
    },
    websocketsend (Data) { // 数据发送
      this.websock.send('严勇')
    },
    websocketclose (e) { // 关闭
      console.log('断开连接', e)
    }
  }
}
</script>
<style lang='less' scoped>
</style>
